import React from 'react';

function TestComponent() {
  return (
    <div
      data-test="test-component"
      className="height-100 width-100 flex-column test-component"></div>
  );
}

export default TestComponent;
